module.exports = __webpack_public_path__ + "img/banner03.c37be088.png";